import { Search, Target, Zap } from 'lucide-react'
import React from 'react'

const steps = [
  {
    number: '01',
    title: 'Busque',
    description: 'Digite o que você procura em linguagem natural. Sem filtros complicados.',
    icon: Search,
    gradient: 'from-blue-500 to-blue-600',
    glow: 'group-hover:shadow-blue-500/30',
  },
  {
    number: '02',
    title: 'Filtre',
    description: 'Nossa IA filtra e organiza os resultados mais relevantes para você.',
    icon: Zap,
    gradient: 'from-violet-500 to-purple-600',
    glow: 'group-hover:shadow-violet-500/30',
  },
  {
    number: '03',
    title: 'Encontre',
    description: 'Obtenha exatamente o que procura, sem perder tempo navegando em vários sites.',
    icon: Target,
    gradient: 'from-cyan-500 to-teal-600',
    glow: 'group-hover:shadow-cyan-500/30',
  },
]

export function HowItWorks() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-blue-50/40 to-white dark:from-zinc-950 dark:via-slate-900/20 dark:to-zinc-950 -z-10" />
      <div className="absolute inset-0 mesh-gradient-vivid -z-10 opacity-30 md:opacity-40" />

      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-20">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-blue-50 border border-blue-100 dark:bg-blue-950/30 dark:border-blue-900/50 px-3 py-1 text-[10px] md:text-xs font-semibold uppercase tracking-widest text-blue-600 dark:text-blue-300 mb-3 md:mb-4">
            Simples e rápido
          </span>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-4 tracking-tight text-slate-900 dark:text-white">
            Como Funciona
          </h3>
          <p className="text-slate-600 dark:text-slate-400 text-base md:text-lg leading-relaxed px-2">
            A tecnologia mais avançada de busca agora focada no que você realmente precisa.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-8 lg:gap-12 relative">
          <div className="hidden md:block absolute top-1/2 left-[20%] right-[20%] h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

          {steps.map((step) => (
            <div key={step.number} className="text-center group relative">
              <div className="relative mx-auto mb-5 md:mb-8 w-fit">
                <div
                  className={`w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br ${step.gradient} flex items-center justify-center shadow-lg ${step.glow} transition-all duration-500 group-hover:scale-110 group-hover:shadow-xl`}
                >
                  <step.icon className="h-6 w-6 md:h-8 md:w-8 text-white" />
                </div>
                <div className="absolute -top-1.5 -right-1.5 md:-top-2 md:-right-2 w-6 h-6 md:w-7 md:h-7 rounded-lg bg-white dark:bg-slate-900 shadow-md flex items-center justify-center border border-gray-100 dark:border-slate-800">
                  <span className="text-[8px] md:text-[10px] font-extrabold text-gray-400">
                    {step.number}
                  </span>
                </div>
              </div>
              <h4 className="text-lg md:text-xl font-bold mb-2 md:mb-3 tracking-tight text-slate-900 dark:text-white">
                {step.title}
              </h4>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed max-w-xs mx-auto text-sm md:text-base">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
